export const PARAM_IFRAME_HEADER_TITLE = 'headerTitle' // chỉ xài ở iframe mini app
export const PARAM_IFRAME_URL = 'url' // chỉ xài ở iframe mini app
export const PARAM_IS_BACK_TO_HOME_MINI_APP = 'isBackToHomeMiniApp' // chỉ xài ở iframe mini app
export const MESSAGE_BACK_TO_HOME_MINI_APP = "BackToHomeMiniApp";  // PostMessage keys: chỉ xài ở iframe mini app

export const PARAM_IS_WEB_VIEW = 'isWebView'
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp';

export const PARAM_REFER_USER_ID = 'referUserId' // id người giới thiệu
export const PARAM_REFER_STATION_ID = 'referStationId' // id trạm giới thiệu
export const PARAM_PAYMENT_METHOD = 'paymentMethodCode' // fixed payment method code
export const PARAM_PAYMENT_THEME_NAME = 'paymentThemeName' // theme for payment method list and payment API host
export const PARAM_IFRAME_PAYMENT = 'IframePayment' // enable paymentLink via /page iframe route
export const PARAM_HIDE_PAYMENT_METHOD = 'hidePaymentMethod' // hide payment method selection
export const PARAM_PAYMENT_STEP_BAR_TYPE = 'paymentStepBarType' // step bar UI variant: baohiem | trungtam
export const PARAM_RETURN_URL = 'returnurl' // redirect url after success
